export function filterNullable<T>(value: T): value is NonNullable<T> {
  return !!value;
}
